// extracted by mini-css-extract-plugin
module.exports = {"brandsList":"Brands_brandsList__YzGpa"};